var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLightbulb = function SvgIconLightbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.123 18v-2H4.565v2zm1.32-6.639c-.48.832-.72 1.723-.96 2.639h-1.44v-3.265l1.08-2.301c.24-.494.12-1.097-.36-1.338-.48-.24-1.08-.024-1.32.47l-.479.988-.84-1.132c-.24-.458-.84-.555-1.32-.23-.479.326-.479.94-.239 1.398l1.56 2.23V14h-1.8c-.12-.855-.48-1.687-.84-2.47l-.96-2.024C.847 6.072 3.246 2 6.965 2c3.839 0 6.358 4.29 4.438 7.735zM6.964 0C1.806 0-1.553 5.639.727 10.41l1.08 2.012c.599 1.205.839 2.53.839 3.867v1.783c0 1.073.84 1.928 1.919 1.928h4.798c.96 0 1.68-.807 1.68-1.795v-1.771c0-1.434.48-2.844 1.079-4.085l.96-1.626C15.72 5.94 12.362 0 6.964 0"
  })));
};
export default SvgIconLightbulb;